import { Injectable } from '@angular/core';
import {
  AngularFirestore,
  AngularFirestoreCollection,
  AngularFirestoreDocument,
} from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PaymentRequestsBeneficiaries } from '../models/paymentRequestsBeneficiaries';
import { rejects } from 'assert';
import { async } from '@angular/core/testing';

@Injectable({
  providedIn: 'root'
})
export class PaymentrequestsBeneficiariesService {

  beneficiaryCollection: AngularFirestoreCollection<PaymentRequestsBeneficiaries>;
  beneficiaryDoc: AngularFirestoreDocument<PaymentRequestsBeneficiaries>;
  beneficiaries: Observable<PaymentRequestsBeneficiaries[]>;
  beneficiary: Observable<PaymentRequestsBeneficiaries>;

  constructor(private afs: AngularFirestore) {
    this.beneficiaryCollection = this.afs.collection('paymentRequestsBeneficiaries', (ref) =>
      ref.orderBy('cmg', 'asc')
    );
  }


  getCompanyBeneficiaries(id: string): Observable<PaymentRequestsBeneficiaries[]> {
    const diespersionsObj: any = this.afs.collection('paymentRequestsBeneficiaries', ref => ref.where('companyId', '==', id)).valueChanges();
    return diespersionsObj;
  }

  getPaymentRequestsBeneficiary(id: string): Observable<PaymentRequestsBeneficiaries> {
    this.beneficiaryDoc = this.afs.doc<PaymentRequestsBeneficiaries>(`paymentRequestsBeneficiaries/${id}`);
    this.beneficiary = this.beneficiaryDoc.snapshotChanges().pipe(
      map((action) => {
        if (action.payload.exists === false) {
          return null;
        } else {
          const data = action.payload.data() as PaymentRequestsBeneficiaries;
          data.id = action.payload.id;
          return data;
        }
      })
    );
    return this.beneficiary;
  }

  newPaymentRequestsBeneficiaries(beneficiary: PaymentRequestsBeneficiaries): Promise<{ beneficiary: PaymentRequestsBeneficiaries } | any> {
    return new Promise(async (resolve, reject) => {
      try {
        const savingNewPaymentRequestsBeneficiaries = await this.beneficiaryCollection.add(
          JSON.parse(JSON.stringify(beneficiary))
        );
        resolve(savingNewPaymentRequestsBeneficiaries.id);
        const myObj: any = {};
        myObj.id = savingNewPaymentRequestsBeneficiaries.id;
        this.updatePaymentRequestsBeneficiaries(myObj.id, myObj);
      } catch (err) {
        reject(err);
      }
    });
  }

  async updatePaymentRequestsBeneficiaries(
    docId: string,
    newData: any
  ): Promise<{ beneficiary: PaymentRequestsBeneficiaries } | any> {
    try {
      let response = await this.afs.doc(`paymentRequestsBeneficiaries/${docId}`).update(newData);
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  deletePaymentRequestsBeneficiaries() {}
}
